(() => {
  const init = (header) => {
    const megas = [...header.querySelectorAll('.nl-mega')];
    megas.forEach((mega) => {
      mega.addEventListener('toggle', () => {
        if (!mega.open) return;
        megas.forEach((other) => { if (other !== mega) other.open = false; });
      });
    });
    header.querySelector('[data-close-mobile]')?.addEventListener('click', () => {
      const mobileMenu = header.querySelector('.nl-mobile-menu');
      if (mobileMenu) mobileMenu.open = false;
    });
    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) megas.forEach((mega) => mega.open = false);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') megas.forEach((mega) => mega.open = false);
    });
  };
  const run = () => document.querySelectorAll('[data-netline-header]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run) : run();
})();
